import { Injectable } from '@angular/core';
import { Toast } from './toast.model';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { generateId } from '../utilities';

@Injectable({
  providedIn: 'root'
})

export class ToastService {

  private toasts: Toast[] = [];
  //private subToast: Subject<Toast[]> = new Subject<Toast[]>();
  private subToast: BehaviorSubject<Toast[]> = new BehaviorSubject<Toast[]>([]);


  //private dataSource: BehaviorSubject<string> = new BehaviorSubject('*');
  //currentData: Observable<string> = this.dataSource.asObservable();



  constructor(

  ) { }

  getToasts(): Observable<Toast[]> {
    return this.subToast.asObservable();
  }

  /**
   * add toast to toasts and create a timeout to delete him
   * @param toast : Toast
   */
  private addToast(toast: Toast): void {
    const itm: Toast[] = this.toasts.filter((t: Toast) => t.title === toast.title);
    if (itm.length === 0) {
      this.toasts = [toast, ...this.toasts];
      this.subToast.next(this.toasts);
      if (toast.closeAuto) {
        setTimeout(() => this.removeToast(toast), toast.timeout);
      }
      if (this.toasts.length > 5) {
        this.removeToast(this.toasts[this.toasts.length - 1]);
      }
    }
  }

  /**
   * remove the toast by his id and clear his timeout from memory
   * @param toast : Toast
   */
  removeToast(toast: Toast): void {
    this.toasts = this.toasts.filter((item: Toast) => item.id !== toast.id);
    this.subToast.next(this.toasts);
  }

  showInfoToast(msg: string, timeout: number = 3000): void {
    this.addToast({
      id: generateId(),
      title: msg,
      faIcon: 'fa-info',
      closeAuto: true,
      timeout: timeout,
      color: '#03A9F4',
      innerContent: `<div class="q-toast-desc" style="overflow: auto;max-height: calc(100vh - 120px);" >${msg}</div>`
    });
  }

  showWarningToast(msg: string, timeout: number = 10000): void {
    this.addToast({
      id: generateId(),
      title: msg,
      faIcon: 'fa-exclamation',
      closeAuto: true,
      timeout: timeout,
      color: '#FF9800',
      innerContent: `<div class="q-toast-desc" style="overflow: auto;max-height: calc(100vh - 120px);" >${msg}</div>`
    });
  }

  showAlertToast(msg: string, timeout: number = 10000, closeAuto: boolean = false): void {
    this.addToast({
      id: generateId(),
      title: msg,
      faIcon: 'fa-exclamation-triangle',
      closeAuto: closeAuto,
      timeout: timeout,
      color: '#f44336',
      innerContent: `<div class="q-toast-desc" style="overflow: auto;max-height: calc(100vh - 120px);" >${msg}</div>`
    });
  }

  showSuccessToast(msg: string, timeout: number = 3000): void {
    this.addToast({
      id: generateId(),
      title: msg,
      faIcon: 'fa-check',
      closeAuto: true,
      timeout: timeout,
      color: '#8BC34A',
      innerContent: `<div class="q-toast-desc" style="overflow: auto;max-height: calc(100vh - 120px);" >${msg}</div>`
    });
  }


  showNotification(msg: string, timeout: number = 10000): void {
    this.addToast({
      id: generateId(),
      title: '1567-NOTIF',
      faIcon: 'fa-exclamation-triangle',
      closeAuto: false,
      timeout: timeout,
      color: '#8BC34A',
      innerContent: `<div class='px-1 py-2'>${msg}</div>`
    });
  }

  blockedPopUpToast(): void {
    this.addToast({
      id: generateId(),
      title: 'POPUPALERT',
      faIcon: 'fa-exclamation-triangle',
      closeAuto: true,
      timeout: 6000,
      color: '#03A9F4',
      innerContent: `<div class="q-toast-desc q-toast-popup" style="text-align: left;"><strong>Si votre navigateur empêche l'ouverture des pop-up</strong> une icône <i>Pop-up bloqués</i>
                    <svg width="21" height="18" viewBox="0 0 700 624">
                      <path id="Element_gris" data-name="Element gris" fill="#fff" d="M20,294H333v30H20V294ZM32,481H333v30H32V481ZM32,97a15,15,0,0,1,15,15V496a15,15,0,0,1-30,0V112A15,15,0,0,1,32,97Zm368,51h30v87H400V148Zm193-1h30v88H593V147ZM32,24H607.625a15,15,0,0,1,15,15V155.25H17V39A15,15,0,0,1,32,24Z"/>
                      <rect id="Element_rouge" data-name="Element rouge" fill="#f34235" x="370.281" y="268.313" width="312" height="311.968" rx="15" ry="15"/>
                      <path id="Croix" fill="#fff" d="M458.769,333.615l168.777,169.3a11.851,11.851,0,0,1,.083,16.6,11.478,11.478,0,0,1-16.383.084L442.469,350.3a11.85,11.85,0,0,1-.083-16.6A11.477,11.477,0,0,1,458.769,333.615Zm167.919-2.245a11.85,11.85,0,0,1,.083,16.6L459.7,519a11.478,11.478,0,0,1-16.384.084,11.85,11.85,0,0,1-.083-16.6L610.3,331.454A11.478,11.478,0,0,1,626.688,331.37Z"/>
                    </svg>
                    s'est affichée dans la barre d'adresse (url).<br />
                    Pensez à paramétrer votre navigateur pour toujours autoriser les pop-up provenant du site <strong>applimetier.com</strong></div>`
    });
  }
}
